import { create } from 'zustand';


export const useSymbolsStore = create((set) => ({
    symbolsList: null,
    searchResultsList: null,
    setSymbolsList: (symbolsList) => set({ symbolsList }),
    setSearchResultsList: (searchResultsList) => set({ searchResultsList }),
}));
